const NOTCH_ZERO = 0;

export { NOTCH_ZERO };
